import React, { useEffect, useRef, useState } from "react";
import { Flex, Input, Button } from "@aws-amplify/ui-react";
import "./ConfirmSignUp.style.css";
import { confirmSignUp } from "aws-amplify/auth";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useEmailStore } from "../store/useEmailStore";

export const ConfirmSignUp: React.FC = () => {
  const [confirmationCode, setConfirmationCode] = useState([
    "",
    "",
    "",
    "",
    "",
    "",
  ]);
  const navigate = useNavigate();
  const email = useEmailStore((state) => state.email);

  const handleInputChange = (e: any, index: any) => {
    const value = e.target.value;
    const newCode = [...confirmationCode];
    newCode[index] = value.slice(0, 1);
    setConfirmationCode(newCode);

    if (value !== "" && index < confirmationCode.length - 1) {
      const nextInput = document.getElementById(
        `input-${index + 1}`
      ) as HTMLInputElement;
      if (nextInput) nextInput.focus();
    }
  };

  const handleConfirmSignUp = async () => {
    try {
      const codeString = confirmationCode.join("");

      await confirmSignUp({
        username: email ?? "",
        confirmationCode: codeString,
      });
      useEmailStore.getState().clearEmail();
      setConfirmationCode(["", "", "", "", "", ""]);
      navigate("/login");
      toast.success("Cadastro confirmado com sucesso!");
    } catch (error) {
      console.log("Error ao confirmar cadastro", error);
      toast.error("Erro ao confirmar cadastro de usuário!");
    }
  };

  return (
    <div className="split-screen">
      <div className="left-side-cadastro">
        <img src="/fundoLogin.png" alt="Login Illustration" className="image" />
      </div>
      <div className="right-side-cadastro">
        <Flex direction="column" gap={3} width={681}>
          <h5 className="confirm-title">Confirmar Cadastro</h5>
          <div className="input-description">
            Um email foi enviado para confirmar seu cadastro. Insira o código de
            confirmação para prosseguir:
          </div>
          <div
            style={{
              display: "flex",
              gap: "24px",
              alignItems: "center",
              justifyContent: "center",
              marginTop: "36px",
            }}
          >
            {confirmationCode.map((digit: any, index: any) => (
              <Input
                id={`input-${index}`}
                className="input-code"
                key={index}
                type="text"
                value={digit}
                onChange={(e) => handleInputChange(e, index)}
                maxLength={1}
                style={{ textAlign: "center" }}
              />
            ))}
          </div>
          <div style={{ textAlign: "right" }}>
            <Button
              className="btn-cadastrar"
              type="submit"
              onClick={handleConfirmSignUp}
            >
              Confirmar
            </Button>
          </div>
        </Flex>
      </div>
    </div>
  );
};
